import { celebrationAttribute } from '../Nodes/CelebrationNode';

export const noop = () => {};

/**
 * Fires once for each celebration mark inside rendered content, the first time it reaches the
 * upper half of the screen. A function rather than renderer behaviour, because published content
 * reaches the reader by more than one path -- HTML banners render straight through v-html.
 *
 * @param {Element} contentElement - DOM element containing rendered rich-text content
 * @param {Function} onCelebrate - Called once per mark, when that mark comes into view
 * @returns {Function} Stops watching; safe to call when there was nothing to watch
 */
export function attachCelebrationObserver(contentElement, onCelebrate) {
    if (!contentElement || !contentElement.querySelectorAll) {
        return noop;
    }

    const marks = contentElement.querySelectorAll(`[${ celebrationAttribute }]`);

    if (marks.length === 0) {
        return noop;
    }

    const observer = new IntersectionObserver((entries, observerInstance) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observerInstance.unobserve(entry.target);
                onCelebrate();
            }
        });
    }, { rootMargin: '0px 0px -50% 0px' });

    marks.forEach(mark => observer.observe(mark));

    return () => observer.disconnect();
}
